
import { useEffect } from 'react';
import { toast } from '../use-toast';

export const usePaymentStatus = (refreshStatus: () => Promise<void>, forceRefreshStatus?: () => Promise<void>) => {
  // Check payment status from URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentStatus = urlParams.get('payment');
    
    if (paymentStatus === 'success') {
      toast({
        title: "Subscription activated",
        description: "Thank you for upgrading to premium!",
      });

      // Remove query params from URL without page refresh
      window.history.replaceState({}, document.title, window.location.pathname);

      // Use force refresh if available for more reliable upgrade detection
      if (forceRefreshStatus) {
        console.log('🔄 Payment Status: Using force refresh after successful payment');
        forceRefreshStatus().catch(error => {
          console.error('❌ Payment Status: Force refresh failed, falling back to regular refresh:', error);
          refreshStatus();
        });
      } else {
        refreshStatus();
      }
    } else if (paymentStatus === 'canceled') {
      toast({
        title: "Subscription not completed",
        description: "Your subscription was not processed. You can try again anytime.",
      });
      
      // Remove query params from URL without page refresh
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [refreshStatus, forceRefreshStatus]);
};
